import React from "react";
import { GlideCarousel } from "../../Glide/glide";
import { collectionToStories } from "@quintype/components";
import { CollectionName } from "../../Atoms/CollectionName";
import { LoadmoreButton } from "../../Atoms/Loadmore";
import { SliderHorizontalCard } from "../../Molecules/SliderHorizontalCard";
import { StateProvider } from "../../SharedContext";
import { getTextColor, getNumberOfStoriesToShow } from "../../../utils/utils";
import PropTypes from "prop-types";

import "./half-screen-slider.m.css";
import "../../../../assets/stylesheets/glide.scss";

const HalfScreenSlider = ({ collection, config = {} }) => {
  const {
    collectionNameBorderColor = "",
    borderColor = "",
    theme = "",
    border = "",
    autoplaySpeed,
    numberOfStoriesToShow = 1,
    collectionNameTemplate,
    animationDuration,
    footerButton = "",
    footerSlotConfig = {}
  } = config;
  const { footerSlot } = footerSlotConfig;
  const items = collectionToStories(collection);
  const textColor = getTextColor(theme);
  const isBorderEnable = border === "full" ? "border" : "";
  if (items.length < 1) {
    return null;
  }
  const options = {
    autoplay: autoplaySpeed,
    animationDuration: animationDuration
  };
  const footerSlotComp = footerSlot ? footerSlot() : null;
  const showNumberOfStoriesToShow = getNumberOfStoriesToShow(numberOfStoriesToShow);
  return (
    <div className="full-width-with-padding arrow-component" style={{ backgroundColor: theme, color: textColor }}>
      <div styleName="half-screen-slider">
        <CollectionName
          collection={collection}
          collectionNameTemplate={collectionNameTemplate}
          collectionNameBorderColor={collectionNameBorderColor}
        />
        <div styleName={`wrapper ${isBorderEnable} ${textColor}`}>
          <GlideCarousel {...options}>
            {items.slice(0, showNumberOfStoriesToShow).map((story, index) => {
              return (
                <SliderHorizontalCard
                  headerLevel="2"
                  key={index}
                  story={story}
                  isHorizontal
                  borderColor={borderColor}
                />
              );
            })}
          </GlideCarousel>
        </div>
      </div>
      <LoadmoreButton template={footerButton} collection={collection} />
      {footerSlotComp}
    </div>
  );
};
export default StateProvider(HalfScreenSlider);
HalfScreenSlider.propTypes = {
  footerButton: PropTypes.string,
  /**  collection is the array of objects which is returning by API  */
  collection: PropTypes.object.isRequired,
  // config is the configuration of the row
  config: PropTypes.object.isRequired,
  // border around the storycard
  border: PropTypes.string,
  // speed of the slider(ms)
  autoplaySpeed: PropTypes.number,
  // no of slides in slider
  numberOfStoriesToShow: PropTypes.number,
  // background and text color configuration
  theme: PropTypes.string,
  // style of the row title
  collectionTemplate: PropTypes.string,
  collectionNameBorderColor: PropTypes.string,
  // section tag border color
  borderColor: PropTypes.string
};
